import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { useApdmCampaignWizard } from '@euler/functions/apdm/useApdmCampaignWizard';
import { canManageApdmImports } from '@euler/functions/apdmAccess';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect, useRef } from 'react';
import { Text } from 'react-native';
import { ApdmCampaignWizard } from './ApdmCampaignWizard';
function WizardContent({
  storeId,
  campaignId,
}: {
  storeId: number;
  campaignId?: string;
}) {
  const wizard = useApdmCampaignWizard(storeId, campaignId);
  const navigation = useAppNavigation();
  const refresh = useRef(wizard.actions.refreshCatalog);
  refresh.current = wizard.actions.refreshCatalog;
  useFocusEffect(
    useCallback(() => {
      void refresh.current();
    }, []),
  );
  return (
    <ApdmCampaignWizard
      wizard={wizard}
      onImport={() => navigation.navigate('ApdmImport', {})}
    />
  );
}
export const ApdmCampaignWizardPage = wrapNavigatorScreen(
  (props: { campaignId?: string }) => {
    const profile = useUserProfileInfo();
    const navigation = useAppNavigation();
    useEffect(() => {
      navigation.setOptions({ title: '客户触达活动向导' });
    }, [navigation]);
    if (!canManageApdmImports(profile ?? null))
      return <Text>当前账号没有活动管理权限，或门店服务不可用。</Text>;
    return (
      <WizardContent
        key={profile!.store.id}
        storeId={profile!.store.id}
        {...props}
      />
    );
  },
);
